// ---- ALL IMPORTS MUST BE AT TOP ----
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import './App.css';
import './media.css'
import { RenderRout } from './router';
// ---- After imports ----
window.bootstrap = bootstrap;
function App() {
  return (
    <div className="App">
      <RenderRout />
    </div>
  );
}

export default App;
